import { isPlatformBrowser } from '@angular/common';
import {
  APP_INITIALIZER, ErrorHandler, NgModule, PLATFORM_ID
} from '@angular/core';
import * as Sentry from '@sentry/angular-ivy';

import { filter, first } from 'rxjs';

import { ConfigurationService, IEnvironmentConfig } from '@sondermind/configuration';
import { DatadogLoggingModule } from '@sondermind/datadog-logging';
import { SentryClient } from '@sondermind/sentry-client';

import { CURRENT_COMMIT_HASH, currentCommitHash } from './current-commit-sha';

function initLoggingServices(configService: ConfigurationService, commitHash: string, platformId): () => Promise<void> {
  return () => new Promise((resolve) => {
    if (!isPlatformBrowser(platformId)) {
      resolve();
    }
    configService.configSubj
      .pipe(
        filter((e) => !!e && Object.keys(e).length !== 0),
        first()
      ).subscribe((config: IEnvironmentConfig) => {
        SentryClient.initialize(config, commitHash);
        DatadogLoggingModule.bootstrap(config);
        resolve();
      });
  });
}

@NgModule({
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initLoggingServices,
      multi: true,
      deps: [
        ConfigurationService,
        CURRENT_COMMIT_HASH,
        PLATFORM_ID
      ]
    },
    {
      provide: CURRENT_COMMIT_HASH,
      useValue: currentCommitHash
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler()
    }
  ]
})
export class LoggingInitModule { }
